<nav class="navbar navbar-expand-lg bg-blue-tadeo">
  <div class="container">
    <a class="navbar-brand" routerLink="/home">
      <img src="./assets/imgs/logo.svg" alt="Logo Tadeo Viajes Blanco" width="130" />
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="material-icons-outlined toggle-menu">menu</span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0" data-animation="bonus">
        <li class="nav-item nav-item-tadeo">
          <a class="nav-link" routerLink="/home">
            Inicio
          </a>
        </li>

        <li class="nav-item nav-item-tadeo" *ngIf="!_authService.user">
          <a class="nav-link" routerLink="/hoteles">
            Alojamiento
          </a>
        </li>

        <li class="nav-item nav-item-tadeo">
          <a class="nav-link" routerLink="/promociones">
            Promociones
          </a>
        </li>
        <!--
        <li class="nav-item nav-item-tadeo">
          <a class="nav-link" (click)="scroll('app')">
            App
          </a>
        </li>
        -->
        <li class="nav-item nav-item-tadeo">
          <a class="nav-link" routerLink="/sucursales">
            Sucursales
          </a>
        </li>
        <li class="nav-item nav-item-tadeo">
          <a class="nav-link" (click)="scroll('nosotros')">
            Nosotros
          </a>
        </li>
        <li class="nav-item nav-item-tadeo">
          <a class="nav-link" routerLink="blog">
            Blog
          </a>
        </li>
        <!--
        <li class="nav-item nav-item-tadeo" *ngIf="!!_authService.user">
          <a class="nav-link" routerLink="/cliente">
            Perfil de cliente
          </a>
        </li>
        -->
        <li class="nav-item nav-item-tadeo" *ngIf="!_authService.user">
          <a class="nav-link" routerLink="/login">
            Iniciar sesión
          </a>
        </li>
        <li class="nav-item nav-item-tadeo" *ngIf="!!_authService.user">
          <a class="nav-link" routerLink="/mis-reservas">
            Mis reservaciones
          </a>
        </li>
        <li class="nav-item nav-item-tadeo" *ngIf="!!_authService.user">
          <a class="nav-link" (click)="logout()">
            Cerrar sesión
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>


<a href="https://api.whatsapp.com/send?phone=+52{{teams[0]?.whatsapp}}&text=%F0%9F%98%80%20Hola,%20quiero%20mas%20informaci%C3%B3n"
  target="_blanck" class="float-whatsapp">
  <img src="../../../assets/imgs/whatsapp-logo.png" style="width: 30px;">
</a>
